var $3d93d7022ddd1ceb$exports = {};
$3d93d7022ddd1ceb$exports = {
    "maximum": `Maksimum`,
    "minimum": `Minimum`
};


export {$3d93d7022ddd1ceb$exports as default};
//# sourceMappingURL=tr-TR.module.js.map
